export default [
  {
    name: 'Dron Mission in Seseña',
    mapLocation: {
      type: 'Feature',
      geometry: {
        type: 'Point',
        coordinates: [-3.6953520571114495, 40.09150705423042]
      },
      properties: {
        zoom: 6
      }
    },
    description:
      'This project contains a video obtained from a flight performed with Ipsilum Aerial Solution'
  }
];
